import { render } from "./PatientDocuments.vue?vue&type=template&id=46c0cff9&ts=true"
import script from "./PatientDocuments.vue?vue&type=script&lang=ts"
export * from "./PatientDocuments.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/armieisla/workspace/charmedteq/icare/icare-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__